import React from 'react'
import Header from './header'
import Footer from './Footer'
import Title from './Title'
import Vspacer from './Vspacer'
import BankInvoiceInfo from './BankInvoiceInfo'
import BankInvoiceFunc from './BankInvoiceFunc'
import VideoImage from './VideoImage'
import QandA from './QandA'
import Back from './back'

// import { injectIntl } from "gatsby-plugin-intl"

// import Header from './Header'
// import Menu from './Menu'
// import Contact from './Contact'
// import Footer from './Footer'

class Layout extends React.Component {

    render() {
        const { children } = this.props

        return (
            <div>
            <Header />
            <Vspacer />
            <Title />
            <VideoImage />
            <Vspacer border="true"/>
            <BankInvoiceInfo /> 
            <Vspacer border="true"/>
            <BankInvoiceFunc />
            <div id="wrapper">
            { children }
            </div>
            <QandA />
            <Back />
            <Footer />
            </div>
        )
    }
}

export default Layout
// export default injectIntl(Layout)

